import React, { useEffect } from "react";
import SignForm from "../../components/SignForm";
import { changeDocumentTitle } from "../../utils/title";

const Signup = () => {

  useEffect(() => {
    changeDocumentTitle("Sign Up");
  }, [])
  return (
    <div className=" flex items-center ">
      {/* Left section with heading, paragraph, and image */}
      <div
        style={{
          flex: 1,
          border: "12px #ccc",
          padding: "15px",
          paddingTop: "2px",
          display: "flex",
          borderTopLeftRadius: '24px',
          borderBottomLeftRadius: '24px',
          flexDirection: "column",
          justifyContent: "center",
          paddingLeft: "45px",
          width: "50%",
          background: `linear-gradient(140.09deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.95) 100%)`,
          // backgroundSize: "cover",
          // backgroundPosition: "center",
          // overflow: "hidden",
          height: "550px"
        }}
      >
        <p className="text-white opacity-65">START FOR FREE</p>
        <h1
          style={{
            fontSize: "38px",
            fontWeight: "bold",
            marginBottom: "10px",
            marginLeft: "0px",
            color: "white",
          }}
        >
          Join <span style={{ color: "#A11C29" }}>Ctrade USA{" "}</span>
          <div style={{ fontSize: "48px" }}>

            <span
              style={{
                fontSize: "38px",
              }}
            >
              Today
            </span>
            {" "}
          </div>

        </h1>
        <p
          style={{
            fontSize: "14px",
            lineHeight: "1.5",
            marginBottom: "15px",
            color: "white",
            width: "80%",
          }}
          className="opacity-65"
        >
          Take control of your logistics with Ctrade. Sign up now to access a powerful suite of tools designed to streamline your operations, whether you're a trucker or a dispatcher.
        </p>
        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.5",
            marginBottom: "15px",
            color: "white",
          }}
        >

        </p>

        <ul className="text-white text-sm opacity-65 space-y-3">
          {[
            "Real time vehicle tracking",
            "Smart invoice and balance control",
            "Easy loading and yard management",
            "Your smarter journey begins here",
          ].map((item, index) => (
            <li key={index} className="flex items-start gap-4">
              <span className="mt-2 h-2 w-2 rounded-full bg-[#A11C29] flex-shrink-0"></span>
              <span className="leading-relaxed">{item}</span>
            </li>
          ))}
        </ul>

      </div>

      <div
        style={{
          paddingLeft: 18,
          height: "550px",
          backgroundColor: "white",
          width: "48%",
          display: "flex",
          alignItems: "center",
          borderTopRightRadius: '24px',
          borderBottomRightRadius: '24px',
        }}
      >
        <SignForm />
      </div>
    </div>

  );
};

export default Signup;
